// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
//@flow
/* eslint-disable */

export type PriorityTag = 'child' | 'pure' | 'barrier' | 'sampler' | 'effect'
export const getPriority = (t: PriorityTag) => {
  switch(t) {
    case 'child': return 0
    case 'pure': return 1
    case 'barrier': return 2
    case 'sampler': return 3
    case 'effect': return 4
    default: return -1
  }
}